import React from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { Loading } from './../../../components/includes/loading';
import { Section, Content, Main, Buttons } from './../../../components/includes/container';
import { ToolbarPrimary } from './../../../components/includes/toolbar';
import { BreadcrumbItem } from './../../../components/includes/breadcrumb';
import { Modal } from './../../../components/includes/modal';
import { Table, Thead, Tbody, Row, Cell, Tresponsive, Ttolbar } from './../../../components/includes/ui/table';
import { Btn, Label } from './../../../components/includes/ui';
import { FormatDate } from './../../../utilities/date';
import { isUndefined, isSorting, isStatus, parseQueryString } from './../../../utilities/utils';
import { PageService } from './../../../services';
import Confirm from './../../shared/confirm';
import PageFilter from './../filter';

const rows = [
  { id: 'title', sort: false, numeric: false, disablePadding: false, label: 'Nombre' },
  { id: 'link', sort: false, numeric: false, disablePadding: false, label: 'Link' },
  { id: 'status', sort: false, numeric: false, disablePadding: false, label: 'Estado' },
  { id: 'created_at', sort: false, numeric: false, disablePadding: false, label: 'Creado' },
  { id: 'updated_at', sort: false, numeric: false, disablePadding: false, label: 'Editado' },
  { id: 'actions', sort: false, numeric: true, disablePadding: false, label: 'Acciones', width:120, minWidth: 120 }
];

class Pages extends React.Component {

  constructor(props){
    super(props);
    this.state = {
      loading: false,
      page: 0,
      order: 'asc',
      orderBy: 'name',
      entities: null,
      formFilterShow: false,
      formDeleteShow: false,
      formDeleteMessage: null
    };
  }

  componentDidMount(){

    // @Pagination
    let page = this.props.match.params.page;

    if(!isUndefined(page)){

      if(!isNaN(page) && page >= 0){

        this._Find(page, parseQueryString(this.props.location.search));

      }else{

        this.props.history.push('/pages');

      }

    }else{

      this._Find(this.state.page, parseQueryString(this.props.location.search));

    }

  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if(this.props.location.search !== prevProps.location.search){
      this._Find(this.state.page, parseQueryString(this.props.location.search));
    }
  }

  /*
  ** @Service
  ** @Description: FindAll
  */

  _Find = (page, query) => {

    PageService.get(page, query).then((response) => {

      this.setState({ loading: true, page: !isUndefined(page) ? parseInt(page,10) : 0, entities: response });

    }).catch((error) => {

      this.props.AlertShow({ open: true, variant: 'error', message: error.data.message });

    });

  }

  /*
  ** @Service
  ** @Description: Update
  */

  _Update = (id) => {

    PageService.find(id).then((response) => {

      // @Dispatch user
      this.props.Update(response);

      // @Redirect
      this.props.history.push(`/users/update/${ id }`);

    }).catch((error) => {

      this.props.AlertShow({ open: true, variant: 'error', message: Error.internal });

    });

  }

  /*
  ** @Service
  ** @Description: Delete
  */

  _Delete = (id) => {

    PageService.remove(id).then((response) => {

      // @State
      this.setState({ formDeleteShow: false });

      // @Service find all by page
      this._Find(this.props.match.params.page);

      // @Dispatch alert success
      this.props.AlertShow({ open: true, variant: 'success', message: `Exito, el registro fue eliminado.` });

    }).catch((error) => {

      // @Dispatch alert error
      this.props.AlertShow({ open: true, variant: 'error', message: Error.internal });

    });

  }

  /*
  ** @Click
  ** @Description: Update user
  */

  handleUpdate = (id) => {
    this._Update(id);
  }

  /*
  ** @Event
  ** @Description: Delete user
  */

  handleDelete = (id, name) => {
    this.setState({
      id: id,
      formDeleteShow: true,
      formDeleteMessage: `¿Confirma la eliminación de ${ name }?`
    });
  }

  /*
  ** @Click
  ** @Description: Delete user
  */

  handleConfirmDeleteConfirm = () => {
    this._Delete(this.state.id);
  }

  /*
  ** @Click
  ** @Description: Cancel delete user
  */

  handleConfirmDeleteCancel = () => {
    this.setState({ formDeleteShow: false });
  }

  /*
  ** @Event
  ** @Description: Add new filter to pages
  */

  handleAddFilter = () => {
    this.setState({ formFilterShow: true });
  }

  /*
  ** @Event
  ** @Description: Close add new filter to pages
  */

  handleCancelAddFilter = () => {
    this.setState({ formFilterShow: false });
  }

  render() {

    const { loading, order, orderBy, entities, formFilterShow } = this.state;

    return (
      <Section>

        <ToolbarPrimary title="Páginas"/>
        <BreadcrumbItem to='/pages'>Páginas</BreadcrumbItem>

        <Content>
          <Main>

            <Confirm
               status={ this.state.formDeleteShow }
               message={ this.state.formDeleteMessage }
               cancel={ () => { this.handleConfirmDeleteCancel() } }
               confirm={ () => { this.handleConfirmDeleteConfirm() } }
            />

            <Modal
                status={ formFilterShow }
                title={ `Filtro` }
                handleCancel={ this.handleCancelAddFilter }
                maxWidth="sm">
                <PageFilter handleSuccess={ this.handleCancelAddFilter }/>
            </Modal>

            <Ttolbar title="Páginas">
              <Buttons>
                { this.props.location.search !== "" && (
                  <Btn color="warning" aria-label="Limpiar filtros" icon="remove" component={ NavLink } to="/pages">
                    Limpiar filtros
                  </Btn>
                )}
                <Btn color="primary" aria-label="filter" icon="filter" onClick={ this.handleAddFilter }>
                  Filtrar
                </Btn>
                <Btn color="success" aria-label="add" icon="add" component={ NavLink } to="/pages/create">
                  Crear página
                </Btn>
              </Buttons>
            </Ttolbar>

            { loading ? (
              <Tresponsive>
                <Table>

                  <Thead rows={ rows } order={ order } orderBy={ orderBy } onRequestSort={ this.handleRequestSort }/>

                  <Tbody>

                    { entities.pages.length > 0 ? (

                      entities.pages.sort(isSorting(order, orderBy)).map(entity => {
                        return (
                          <Row key={ entity._id }>
                            <Cell>{ entity.title }</Cell>
                            <Cell>{ entity.slug }</Cell>
                            <Cell>
                              <Label variant={ entity.status ? "success" : "danger"}>
                                { isStatus(entity.status) }
                              </Label>
                            </Cell>
                            <Cell>
                              <FormatDate value={ entity.created_at }/>
                            </Cell>
                            <Cell>
                              <FormatDate value={ entity.updated_at }/>
                            </Cell>
                            <Cell numeric>
                              <Btn color="danger" size="xsmall" icon="remove" onClick={ () => { this.handleDelete(entity._id, `${ entity.title }`) } }/>
                              <Btn color="primary" size="xsmall" icon="edit" component={ NavLink } to={ `/pages/update/${ entity._id }` }/>
                            </Cell>
                          </Row>
                        );
                      })

                    ) : (

                      <Row key="1">
                        <Cell colSpan={ rows.length }>No se encontraron resultados.</Cell>
                      </Row>

                    )}

                  </Tbody>
                </Table>
              </Tresponsive>
            ) : (
              <Loading variant="primary"/>
            ) }

          </Main>
        </Content>
      </Section>
    )
  }

}

const mapStateToProps = (state) => {
  return {
    Alert: state.Alert
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    AlertShow: (data) => {
      dispatch({
        type: 'ALERT_SHOW',
        data: data
      });
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Pages);
